// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import { connect } from 'react-redux'
import { getFormSubmitErrors } from 'redux-form'
import { ErrorsList } from 'components'

// NOTE - this component displays two distinct types of submit error messages from redux-form.

// 1)
// When throwing a SubmissionError, you can include a prop called '_error' which redux-form
// treats as a general form-level error. By default, this value clears after a change
// has taken place on the form post submission failure.
// This value is also NOT include in the form's submitErrors object.
// 2)
// If we include properties which do not map to any field names when throwing SubmissionError,
// we are able to store in the submitErrors object, any number of error messages to display to the user.
// This is helpful when you need to communicate a validation error to the user
// but it does not map directly to a single input field.
// Imagine for example, telling the user that Site 1 Coords and Site 2 coords cannot be the same
// or if the user uploaded a CSV which itself contains invalid data.
// for such a scenario, the API will return a 'not ok' HTTP status (like 422 or sth)
// and the response body will contain a 'message' and an 'errors' array.
// With the intention of displaying this information to the user we take these values
// and assign them the to an object called _apiErrors
// This component then looks for these properties to display to the user.

// NOTE - because of how redux-form operates, if you want to display the '_error',
// you must call this component from within the <Form /> itself and pass that down
// as a prop

const SubmitErrors = props => {
  const {
    errors,
    idRoot,
    message,
  } = props

  return (
    <ErrorsList
      errors={errors}
      idRoot={idRoot}
      message={message} />
  )
}

SubmitErrors.propTypes = {
  errors: array,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
  message: string,
}

const mapStateToProps = ({ form }, { error, sourceForm }) => {
  const submitErrors = getFormSubmitErrors(sourceForm)({ form })

  const message = submitErrors?._apiErrors?.message || error
  const errors = submitErrors?._apiErrors?.errors

  return {
    errors,
    message,
  }
}

export default connect(
  mapStateToProps,
)(SubmitErrors)
